import { useState, useRef, useEffect, useCallback } from 'react';
import { ReactComponent as CloseIcon } from "../../../../../Assets/icon/close.svg";
import { ReactComponent as PlusIcon } from "../../../../../Assets/icon/plus-gray.svg";
import { ReactComponent as CheckIcon } from "../../../../../Assets/icon/Check-white.svg";
import searchIcon from "../../../../../Assets/images/searchIcon.png"
import { getRelationships } from "../../../../../Services/Realtionship"
import "./style.css"
import ContentLoader from '../../../../LoadingPage/ContentLoader';
import Loader from 'react-js-loader';

const SendInvite = ({ onClose, hideCloseIcon, setPartnerID, handleInvite, loading }) => {

  const [activeFilter, setActiveFilter] = useState('all');
  const [gridLoading, setGridLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const isFetching = useRef(false);
  const [selectedContact, setSelectedContact] = useState(null);

  const fetchRelationships = useCallback(async () => {
    if (isFetching.current) return;
    isFetching.current = true;
    setGridLoading(true);
    try {
      const relationshipsData = await getRelationships(
        activeFilter === "all" ? "" : activeFilter
      );
      const acceptedContacts = relationshipsData.filter(contact => contact.relation_status === 'accepted');
      setContacts(acceptedContacts);
      setFilteredContacts(acceptedContacts);
    } catch (error) {
      console.error("Failed to fetch relationships:", error);
      setContacts([]);
      setFilteredContacts([]);
    } finally {
      isFetching.current = false;
      setGridLoading(false);
    }
  }, [activeFilter]);

  useEffect(() => {
    fetchRelationships();
  }, [fetchRelationships]);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredContacts(contacts);
      return;
    }

    const filtered = contacts.filter(contact => {
      const fullName = `${contact.first_name} ${contact.last_name}`.toLowerCase();
      return fullName.includes(searchTerm.toLowerCase());
    });

    setFilteredContacts(filtered);
  }, [searchTerm, contacts]);

  const handleSelectContact = (contact) => {
    if (selectedContact && selectedContact.email === contact.email) {
      setSelectedContact(null);
    } else {
      setSelectedContact({
        id: contact._id,
        email: contact.email,
        firstName: contact.first_name,
        lastName: contact.last_name,
        user_id: contact.user2_id,
      });
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const getInitials = (firstName, lastName) => {
    if (!firstName && !lastName) return '';
    if (!firstName) return lastName[0]?.toUpperCase() || '';
    if (!lastName) return firstName[0]?.toUpperCase() || '';
    return `${firstName[0]?.toUpperCase()}${lastName[0]?.toUpperCase()}`;
  };


  return (
    <div className='coaching-send-invite-container'>
      <div className="coaching-send-invite-header">
        <p>Send invitation to your session partner</p>
        {!hideCloseIcon && <CloseIcon style={{ cursor: 'pointer' }} onClick={onClose} />}
      </div>
      <div className="coaching-send-invite-search-bar">
        <span><img src={searchIcon} alt='search' /></span>
        <input
          type="text"
          placeholder='Search by name'
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>
      <div className="coaching-send-invite-filter-chips-container">
        {['all', 'dating', 'marriage', 'family', 'friends', 'workplace', 'roommates', 'other'].map(filter => ( // 
          <div key={filter} className={`chip-item ${activeFilter === filter && 'active'}`} onClick={() => setActiveFilter(filter)}>
            {filter.charAt(0).toUpperCase() + filter.slice(1)}
          </div>
        ))}
      </div>
      {gridLoading ? <ContentLoader /> : (
        <>
          <div className={`coaching-send-invite-profiles-container ${filteredContacts?.length <= 0 && 'no-contacts'}`}>
            {filteredContacts.length > 0 ? (
              filteredContacts.map((contact) => (
                <div key={contact.email} className="coaching-send-invite-profile-item">
                  <div className="coaching-send-invite-profile-item-left">
                    <div className="coaching-send-invite-profile-item-image">
                      {contact.profile_pic_url ? (
                        <img src={contact.profile_pic_url} alt={getInitials(contact.first_name, contact.last_name)} />
                      ) : (
                        <div className="initials">
                          {getInitials(contact.first_name, contact.last_name)}
                        </div>
                      )}
                    </div>
                    <div className="coaching-send-invite-profile-item-details">
                      <p className='coaching-send-invite-profile-item-name'>{contact.first_name + " " + contact.last_name}</p>
                      <p className='coaching-send-invite-profile-item-relationship'>{contact.related_data.relationship_category}</p>
                    </div>
                  </div>
                  <div className="coaching-send-invite-profile-item-right">
                    <div
                      className={`coaching-send-invite-add-button-conatiner ${selectedContact && selectedContact.email === contact.email && 'added'}`}
                      onClick={() => handleSelectContact(contact)}
                    >
                      {selectedContact && selectedContact.email === contact.email ? (
                        <>
                          Added
                          <CheckIcon />
                        </>
                      ) : (
                        <>
                          Add
                          <PlusIcon />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))) : (
              <div className="no-results text-center">No contacts found</div>
            )
            }
          </div>
          <div className="coaching-send-invite-footer">
            <div className="coaching-send-invite-footer-button-conatiner" onClick={() => handleInvite()}>Skip</div>
            <div
              className={`coaching-send-invite-footer-button-conatiner ${loading && 'loading'} ${!selectedContact && 'disabled'}`}
              onClick={() => {
                if (selectedContact) {
                  setPartnerID(selectedContact.user_id);
                  handleInvite();
                }
              }}
            >
              {loading ? (
                <Loader
                  type="spinner-cub"
                  bgColor={"#fff"}
                  color={"#3D6DEB"}
                  // title={"spinner-cub"}
                  size={30}
                />
              ) : (
                <>
                  {selectedContact ? `Invite ${selectedContact.firstName} ${selectedContact.lastName}` : 'Invite'}
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default SendInvite